export const LANGUAGES = [
  { code: 'en', flag: 'gb', label: 'English', name: 'English' },
  { code: 'th', flag: 'th', label: 'ไทย', name: 'Thai' },
  { code: 'af', flag: 'za', label: 'Afrikaans', name: 'Afrikaans' },
  { code: 'am', flag: 'et', label: 'አማርኛ', name: 'Amharic' },
  { code: 'ar', flag: 'sa', label: 'العربية', name: 'Arabic' },
  { code: 'as', flag: 'in', label: 'অসমীয়া', name: 'Assamese' },
  { code: 'ay', flag: 'bo', label: 'Aymar Ar', name: 'Aymara' },
  { code: 'az', flag: 'az', label: 'Azərbaycan dili', name: 'Azerbaijani' },
  { code: 'be', flag: 'by', label: 'Беларуская', name: 'Belarusian' },
  { code: 'bg', flag: 'bg', label: 'Български', name: 'Bulgarian' },
  { code: 'bho', flag: 'in', label: 'भोजपुरी', name: 'Bhojpuri' },
  { code: 'bm', flag: 'ml', label: 'Bamanankan', name: 'Bambara' },
  { code: 'bn', flag: 'bd', label: 'বাংলা', name: 'Bangla' },
  { code: 'bs', flag: 'ba', label: 'Bosanski', name: 'Bosnian' },
  { code: 'ca', flag: 'es', label: 'Català', name: 'Catalan' },
  { code: 'ceb', flag: 'ph', label: 'Cebuano', name: 'Cebuano' },
  { code: 'ckb', flag: 'iq', label: 'کوردیی ناوەندی', name: 'Central Kurdish' },
  { code: 'co', flag: 'fr', label: 'Corsu', name: 'Corsican' },
  { code: 'cs', flag: 'cz', label: 'Čeština', name: 'Czech' },
  { code: 'cy', flag: 'gb-wls', label: 'Cymraeg', name: 'Welsh' },
  { code: 'da', flag: 'dk', label: 'Dansk', name: 'Danish' },
  { code: 'de', flag: 'de', label: 'Deutsch', name: 'German' },
  { code: 'dv', flag: 'mv', label: 'ދިވެހި', name: 'Divehi' },
  { code: 'doi', flag: 'in', label: 'Dogri', name: 'Dogri' },
  { code: 'ee', flag: 'gh', label: 'Eʋegbe', name: 'Ewe' },
  { code: 'el', flag: 'gr', label: 'Ελληνικά', name: 'Greek' },
  { code: 'eo', flag: 'eu', label: 'Esperanto', name: 'Esperanto' },
  { code: 'es', flag: 'es', label: 'Español', name: 'Spanish' },
  { code: 'et', flag: 'ee', label: 'Eesti', name: 'Estonian' },
  { code: 'eu', flag: 'es', label: 'Euskara', name: 'Basque' },
  { code: 'fa', flag: 'ir', label: 'فارسی', name: 'Persian' },
  { code: 'fi', flag: 'fi', label: 'Suomi', name: 'Finnish' },
  { code: 'fr', flag: 'fr', label: 'Français', name: 'French' },
  { code: 'fy', flag: 'nl', label: 'Frysk', name: 'Frisian' },
  { code: 'ga', flag: 'ie', label: 'Gaeilge', name: 'Irish' },
  { code: 'gd', flag: 'gb-sct', label: 'Gàidhlig', name: 'Scottish Gaelic' },
  { code: 'gl', flag: 'es', label: 'Galego', name: 'Galician' },
  { code: 'gn', flag: 'py', label: 'Avañeʼẽ', name: 'Guarani' },
  { code: 'gu', flag: 'in', label: 'ગુજરાતી', name: 'Gujarati' },
  { code: 'ha', flag: 'ng', label: 'Hausa', name: 'Hausa' },
  { code: 'haw', flag: 'us', label: 'ʻŌlelo Hawaiʻi', name: 'Hawaiian' },
  { code: 'he', flag: 'il', label: 'עברית', name: 'Hebrew' },
  { code: 'hi', flag: 'in', label: 'हिन्दी', name: 'Hindi' },
  { code: 'hmn', flag: 'cn', label: 'Hmong', name: 'Hmong' },
  { code: 'hr', flag: 'hr', label: 'Hrvatski', name: 'Croatian' },
  { code: 'ht', flag: 'ht', label: 'Kreyòl ayisyen', name: 'Haitian Creole' },
  { code: 'hu', flag: 'hu', label: 'Magyar', name: 'Hungarian' },
  { code: 'hy', flag: 'am', label: 'Հայերեն', name: 'Armenian' },
  { code: 'id', flag: 'id', label: 'Indonesia', name: 'Indonesian' },
  { code: 'ig', flag: 'ng', label: 'Igbo', name: 'Igbo' },
  { code: 'ilo', flag: 'ph', label: 'Ilocano', name: 'Ilocano' },
  { code: 'is', flag: 'is', label: 'Íslenska', name: 'Icelandic' },
  { code: 'it', flag: 'it', label: 'Italiano', name: 'Italian' },
  { code: 'ja', flag: 'jp', label: '日本語', name: 'Japanese' },
  { code: 'jv', flag: 'id', label: 'Basa Jawa', name: 'Javanese' },
  { code: 'ka', flag: 'ge', label: 'ქართული', name: 'Georgian' },
  { code: 'kk', flag: 'kz', label: 'Қазақ', name: 'Kazakh' },
  { code: 'km', flag: 'kh', label: 'ភាសាខ្មែរ', name: 'Khmer' },
  { code: 'kn', flag: 'in', label: 'ಕನ್ನಡ', name: 'Kannada' },
  { code: 'ko', flag: 'kr', label: '한국어', name: 'Korean' },
  { code: 'kri', flag: 'sl', label: 'Krio', name: 'Krio' },
  { code: 'ku', flag: 'iq', label: 'Kurdî', name: 'Kurdish (Kurmanji)' },
  { code: 'ky', flag: 'kg', label: 'Кыргызча', name: 'Kyrgyz' },
  { code: 'la', flag: 'va', label: 'Latina', name: 'Latin' },
  { code: 'lb', flag: 'lu', label: 'Lëtzebuergesch', name: 'Luxembourgish' },
  { code: 'lg', flag: 'ug', label: 'Luganda', name: 'Luganda' },
  { code: 'ln', flag: 'cd', label: 'Lingála', name: 'Lingala' },
  { code: 'lo', flag: 'la', label: 'ລາວ', name: 'Lao' },
  { code: 'lt', flag: 'lt', label: 'Lietuvių', name: 'Lithuanian' },
  { code: 'lus', flag: 'in', label: 'Mizo', name: 'Mizo' },
  { code: 'lv', flag: 'lv', label: 'Latviešu', name: 'Latvian' },
  { code: 'mg', flag: 'mg', label: 'Malagasy', name: 'Malagasy' },
  { code: 'mi', flag: 'nz', label: 'Māori', name: 'Maori' },
  { code: 'mk', flag: 'mk', label: 'Македонски', name: 'Macedonian' },
  { code: 'ml', flag: 'in', label: 'മലയാളം', name: 'Malayalam' },
  { code: 'mn', flag: 'mn', label: 'Монгол', name: 'Mongolian' },
  { code: 'mni', flag: 'in', label: 'Meitei / Manipuri', name: 'Meitei (Manipuri)' },
  { code: 'mr', flag: 'in', label: 'मराठी', name: 'Marathi' },
  { code: 'ms', flag: 'my', label: 'Bahasa Melayu', name: 'Malay' },
  { code: 'mt', flag: 'mt', label: 'Malti', name: 'Maltese' },
  { code: 'my', flag: 'mm', label: 'မြန်မာ', name: 'Burmese' },
  { code: 'ne', flag: 'np', label: 'नेपाली', name: 'Nepali' },
  { code: 'nl', flag: 'nl', label: 'Nederlands', name: 'Dutch' },
  { code: 'no', flag: 'no', label: 'Norsk', name: 'Norwegian' },
  { code: 'nso', flag: 'za', label: 'Sesotho sa Leboa', name: 'Northern Sotho' },
  { code: 'ny', flag: 'mw', label: 'ChiCheŵa', name: 'Chichewa' },
  { code: 'om', flag: 'et', label: 'Afaan Oromoo', name: 'Oromo' },
  { code: 'or', flag: 'in', label: 'ଓଡ଼ିଆ', name: 'Odia' },
  { code: 'pa', flag: 'in', label: 'ਪੰਜਾਬੀ', name: 'Punjabi' },
  { code: 'pl', flag: 'pl', label: 'Polski', name: 'Polish' },
  { code: 'ps', flag: 'af', label: 'پښتو', name: 'Pashto' },
  { code: 'pt', flag: 'pt', label: 'Português', name: 'Portuguese' },
  { code: 'qu', flag: 'pe', label: 'Runasimi', name: 'Quechua' },
  { code: 'ro', flag: 'ro', label: 'Română', name: 'Romanian' },
  { code: 'ru', flag: 'ru', label: 'Русский', name: 'Russian' },
  { code: 'rw', flag: 'rw', label: 'Kinyarwanda', name: 'Kinyarwanda' },
  { code: 'sa', flag: 'in', label: 'संस्कृतम्', name: 'Sanskrit' },
  { code: 'sd', flag: 'pk', label: 'سنڌي', name: 'Sindhi' },
  { code: 'si', flag: 'lk', label: 'සිංහල', name: 'Sinhala' },
  { code: 'sk', flag: 'sk', label: 'Slovenčina', name: 'Slovak' },
  { code: 'sl', flag: 'si', label: 'Slovenščina', name: 'Slovenian' },
  { code: 'sm', flag: 'ws', label: 'Gagana Sāmoa', name: 'Samoan' },
  { code: 'sn', flag: 'zw', label: 'Shona', name: 'Shona' },
  { code: 'so', flag: 'so', label: 'Soomaali', name: 'Somali' },
  { code: 'sq', flag: 'al', label: 'Shqip', name: 'Albanian' },
  { code: 'sr', flag: 'rs', label: 'Српски', name: 'Serbian' },
  { code: 'st', flag: 'za', label: 'Sesotho', name: 'Southern Sotho' },
  { code: 'su', flag: 'id', label: 'Basa Sunda', name: 'Sundanese' },
  { code: 'sv', flag: 'se', label: 'Svenska', name: 'Swedish' },
  { code: 'sw', flag: 'tz', label: 'Kiswahili', name: 'Swahili' },
  { code: 'ta', flag: 'in', label: 'தமிழ்', name: 'Tamil' },
  { code: 'te', flag: 'in', label: 'తెలుగు', name: 'Telugu' },
  { code: 'tg', flag: 'tj', label: 'Тоҷикӣ', name: 'Tajik' },
  { code: 'ti', flag: 'er', label: 'ትግርኛ', name: 'Tigrinya' },
  { code: 'tk', flag: 'tm', label: 'Türkmen', name: 'Turkmen' },
  { code: 'tl', flag: 'ph', label: 'Tagalog', name: 'Tagalog' },
  { code: 'tr', flag: 'tr', label: 'Türkçe', name: 'Turkish' },
  { code: 'ts', flag: 'za', label: 'Xitsonga', name: 'Tsonga' },
  { code: 'tt', flag: 'ru', label: 'Tatar', name: 'Tatar' },
  { code: 'ug', flag: 'cn', label: 'ئۇيغۇرچە', name: 'Uyghur' },
  { code: 'uk', flag: 'ua', label: 'Українська', name: 'Ukrainian' },
  { code: 'ur', flag: 'pk', label: 'اردو', name: 'Urdu' },
  { code: 'uz', flag: 'uz', label: 'Oʻzbekcha', name: 'Uzbek' },
  { code: 'vi', flag: 'vn', label: 'Tiếng Việt', name: 'Vietnamese' },
  { code: 'xh', flag: 'za', label: 'isiXhosa', name: 'Xhosa' },
  { code: 'yi', flag: 'il', label: 'ייִדיש', name: 'Yiddish' },
  { code: 'yo', flag: 'ng', label: 'Yorùbá', name: 'Yoruba' },
  { code: 'zh', flag: 'cn', label: '中文', name: 'Chinese (Simplified/Traditional)' },
  { code: 'zu', flag: 'za', label: 'IsiZulu', name: 'Zulu' }
]
